/*
* @Author: Mark Miller
* @Date:   2018-08-29 23:18:31
* @Last Modified by:   msmiller
* @Last Modified time: 2019-12-15 14:29:23
*
* Copyright (c) 2017-2018 Sharp Stone Codewerks / Mark S. Miller
*/

import { Controller } from "stimulus"

export default class extends Controller {

    initialize() {
    }

    connect() {
      // console.log("-=> send_controller connected");

      // Initialize the tab control
      $('.menu .item')
        .tab({
          // Set the hidden variable so the back-end knows which mode we're in
          onVisible: function(settings) {
            $("#selected_tab").val(settings);
           }
        })
      ;


      var REGEX_EMAIL = '([a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@' +
                        '(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)';

      $('#contact_select').selectize({
          persist: false,
          maxItems: null,
          valueField: 'email',
          labelField: 'name',
          searchField: ['name', 'email'],
          options: CONTACT_LIST,
          render: {
              item: function(item, escape) {
                  return '<div>' +
                      (item.name ? '<span class="name">' + escape(item.name) + '</span>' : '') +
                      (item.email ? '<span class="email">' + escape(item.email) + '</span>' : '') +
                  '</div>';
              },
              option: function(item, escape) {
                  var label = item.name || item.email;
                  var caption = item.name ? item.email : null;
                  return '<div>' +
                      '<span class="label">' + escape(label) + '</span>' +
                      (caption ? '<span class="caption">' + escape(caption) + '</span>' : '') +
                  '</div>';
              }
          },
          createFilter: function(input) {
              var match, regex;

              // email@address.com
              regex = new RegExp('^' + REGEX_EMAIL + '$', 'i');
              match = input.match(regex);
              if (match) return !this.options.hasOwnProperty(match[0]);

              // name <email@address.com>
              regex = new RegExp('^([^<]*)\<' + REGEX_EMAIL + '\>$', 'i');
              match = input.match(regex);
              if (match) return !this.options.hasOwnProperty(match[2]);

              return false;
          },
          create: function(input) {
              if ((new RegExp('^' + REGEX_EMAIL + '$', 'i')).test(input)) {
                  return {email: input};
              }
              var match = input.match(new RegExp('^([^<]*)\<' + REGEX_EMAIL + '\>$', 'i'));
              if (match) {
                  return {
                      email : match[2],
                      name  : $.trim(match[1])
                  };
              }
              alert('Invalid email address.');
              return false;
          }
      });
    }

    toggleReconfigButton() {
      $('#tag_reconfigure').slideToggle();
      $('#reconfig_button').toggleClass('black');
      $('#reconfig_button').toggleClass('grey');
      $('#reconfig_button').text(($('#reconfig_button').text() == 'Adjust Tags For This Send') ? '(FINISHED)' : 'Adjust Tags For This Send');
    }

    showResumePreviewModal() {
      var transient_id = this.data.get("transientid");
      var preview_path = "/resumes/" + transient_id + "/preview"
      $('#resprev').attr('src', preview_path);
      $('#resume_preview_modal')
        .modal('show')
      ;
    };

    loadCoverLetter() {
      $( "#coverletter-edit" ).load( "/send/ajax_cover_letter/" + event.currentTarget.value);
    }

    showCoverModal() {
      $( "#cover_letter_body" ).load( encodeURI( "/cover_letters/1/ajax_body_raw?job=" + $( "#position_name" ).val() ), "raw=" + $( "#coverletter-edit" ).val().replace(/\n/g,'<br/>') );
      $('#preview_modal').modal('show');
    }

    rebuildPreview() {
      var selectorParams = "";
      var radioVal;
      TAGIDS.map( function(item) {
        radioVal = 'input:radio[name="selectors[' + item + ']"]:checked';
        selectorParams += "&selectors[" + item + "]=" + $(radioVal).val();
      })
      //console.log(selectorParams);
      $.get( "/send/reconfigure?prospect_id=" + PROSPECTID + selectorParams, function( data ) {
        $( "#piece_preview" ).html( data );
      });
    }

    toggleMergeTagsHelp() {
      $('#merge_tags_help').fadeToggle();
    }

  };

// console.log("-=> send_controller loaded");
